<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        Payment History
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">Billing</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Payment</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date"> Paid_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Payment Success</label>
        </b-col>
        <!-- <c-switch color="info" label size="sm" v-model="so.opt['is_success']" @change="change" /> -->
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_success']" @change="change" />
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">Group Name</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!group_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_group" :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">Select Group</b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">Partner Name</label>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="partner_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('partner')">Clear</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!partner_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_partner" :variant="partner_name ? 'primary' : 'add'" @click="chainPartner = true">Select Partner</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">TOTAL : <span style="padding-left: 1rem"></span>{{(model.total_paid || 0).toString().padStart(10, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_info mb-2">Success : <span style="padding-left: 0.5rem"></span>{{(model.paid || 0).toString().padStart(10, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_danger mb-2">Failed : <span style="padding-left: 1.2rem"></span>{{(model.failed || 0).toString().padStart(10, nbsp) | dollar}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" :text="so.skt || 'Search'" size="sm" v-model="so.sk" name="sel1" id="sel1" @change="sv_reset">
              <option disabled value="">Search</option>
              <option value="partner.username">Partner</option>
              <option value="group.groupname">Group</option>
              <option value="method">Method</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <!-- <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div> -->
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">
              {{ row.item.created_at | sdate }}
            </template>
            <template slot="partner" slot-scope="row">
              {{row.item.partner && row.item.partner.username ? row.item.partner.username : '-'}}
            </template>
            <template slot="group" slot-scope="row">
              {{row.item.group && row.item.group.groupname ? row.item.group.groupname : '-'}}
            </template>
            <template slot="result" slot-scope="row">
              <b-badge :variant="!row.item.is_success ? 'danger' : 'success'">{{ !row.item.is_success ? 'Failed' : 'Success' }}</b-badge>
            </template>
            <template slot="method" slot-scope="row">
              <span> {{row.item.method || '-'}} </span>
            </template>
            <template slot="pay_amount" slot-scope="row">
              <span> {{row.item.pay_amount | dollar}} </span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- grouop modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- partner modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Partner and Select" size="xl" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @selected="setPartner"></partner-List>
    </b-modal>
    <!-- payment history modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Payment Info" size="x" v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only ok-variant="outline-primary">
      <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
      <table class="table table-striped" v-if="payment_history">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Purchased Date</th>
            <td>
              {{ (payment_history && payment_history.payer ? payment_history.purchase_units[0].payments.captures[0].create_time : payment_history.purchased_at) | sdate }}
            </td>
          </tr>
          <tr>
            <th scope="row">Company</th>
            <td>
              {{payment_history && payment_history.payer ? payment_history.payer.email_address : (payment_history.pg_name ? payment_history.pg_name : '-') }}
            </td>
          </tr>
          <tr>
            <th scope="row">Action</th>
            <td>
              {{payment_history && payment_history.payer ? payment_history.purchase_units[0].description : (payment_history.action ? payment_history.action : '-') }}
            </td>
          </tr>
          <tr>
            <th scope="row">Method</th>
            <td>
              {{payment_history && payment_history.payer ? payment_history.pg : (payment_history.pg ? payment_history.pg : '-') }}
            </td>
          </tr>
          <tr>
            <th scope="row">Price</th>
            <td>
              {{ (payment_history && payment_history.payer ? payment_history.purchase_units[0].amount.value : payment_history.price) | dollar }}
            </td>
          </tr>
          <tr>
            <th scope="row">Currency</th>
            <td>
              {{payment_history && payment_history.payer ? payment_history.purchase_units[0].amount.currency_code : 'KRW' }}
            </td>
          </tr>
          <tr>
            <th scope="row">Country</th>
            <td>
              {{payment_history && payment_history.payer ? payment_history.payer.address.country_code : 'KOR' }}
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>